<div
  class="card card-shadow"
  [class.bg-grey]="disableButton && payrollStartData?.ActivePayroll?.PayType != 3">
  <div class="card-body d-flex flex-column">
    <h3 class="card-title">Off Cycle Payroll</h3>
    <h6
      *ngIf="isPrefundLocked && payrollStartData?.ActivePayroll?.PayType == 3 && isPayDateInvalid"
      class="flex-grow-1">
      This payroll cannot be resumed as the pay date is no longer valid. Please contact your CSR for
      further help or cancel the payroll.
    </h6>
    <h6
      *ngIf="!isPrefundLocked || payrollStartData?.ActivePayroll?.PayType != 3"
      class="flex-grow-1">
      Run a Bonus or additional payroll.
    </h6>
    <div *ngIf="payrollStartData?.ActivePayroll && payrollStartData?.ActivePayroll?.PayType == 3">
      <h6 class="cp-green fw-bold mb-0">Entry in progress</h6>
      <small class="cp-green">
        Last edit by {{ payrollStartData.ActivePayroll.LastEditBy }} on
        {{ payrollStartData.ActivePayroll.LastEditOn | date: 'MM/dd/yyyy h:mma' }}
      </small>
    </div>

    <div
      *ngIf="
        payrollStartData?.ActivePayroll &&
        payrollStartData?.ActivePayroll?.PayType == 3 &&
        isPayDateInvalid
      ">
      <h5>
        This payroll is overdue and cannot be resumed. Cancel the payroll to proceed. If you have
        any questions, contact your Payroll Specialist.
      </h5>
    </div>
    <div class="d-flex justify-content-end align-items-center mt-auto">
      <button
        *ngIf="
          payrollStartData?.ActivePayroll &&
          payrollStartData?.ActivePayroll?.PayType == 3 &&
          isPayDateInvalid
        "
        type="button"
        (click)="cancelPayroll()"
        class="btn btn-danger float-end mt-4 me-4 align-self-end">
        Cancel Payroll
      </button>
      <button
        *ngIf="!isPayDateInvalid"
        type="button"
        [disabled]="disableButton"
        (click)="navigatePayroll()"
        class="btn btn-primary float-end mt-4 align-self-end"
        data-testid="run-off-cycle-payroll-tile-btn">
        {{ buttonText }}
      </button>
    </div>
  </div>
</div>
